// Presentation only; never use display placeholders as record identities.
export function structuredValue(value) {
  if (value === null || value === undefined ||
      (typeof value === "string" && ["", "-", "—"].includes(value.trim())) ||
      (typeof value === "number" && Number.isNaN(value))) return "NA";
  return value;
}

export function isTechnicalFailed(value) {
  return String(value ?? "").trim().toLowerCase() === "failed";
}

export function presentedStatus(value, isSuperAdmin, isVendor, failureKind = "") {
  if (failureKind === "confirmed") return isVendor ? "Submitted" : "Failed";
  return !isSuperAdmin && isTechnicalFailed(value)
    ? (isVendor ? "Submitted" : "Queued") : value;
}
